import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing.medium,
    gap: theme.spacing.xLarge,
    alignItems: "stretch",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,
}));

export const IconAndTitleContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: theme.spacing.large,
    width: "100%",
}));

export const TitleContainer = styled.div({
    width: "100%",
});

export const TextContainer = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: theme.spacing.small,
}));

export const DescriptionContainer = styled.div(() => ({
    width: "100%",
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.small,
    width: "100%",
    marginTop: "auto",
    marginBottom: theme.spacing.small,
}));

export const FlexCta = styled.div({
    flex: "1 1 0",
});
